import styled from "styled-components";

export const Features = styled.div`
  margin-top: 4.8rem;
`;

export const Feature = styled.div`
  display: flex;

  &:not(:first-child) {
    margin-top: 2.4rem;
  }

  ${({ theme }) => theme.media.sm`
    flex-direction: column;
    margin-top: 3.2rem;

    &:not(:first-child) {
      margin-top: 3.2rem;
    }
  `}
`;

export const FeatureImage = styled.img`
  max-width: 26rem;
  width: 100%;
  margin-right: 3.4rem;
  flex-shrink: 0;
  object-fit: contain;

  ${({ theme }) => theme.media.sm`
    margin: 0 0 1.2rem;
  `}
`;
